import ClearIcon from '@mui/icons-material/Clear';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { getInfluencerListFordashboard } from '../../pages/dashboard/action';
import { updateDashboard } from '../../pages/dashboard/dashboardSlice';
import { setSearchdata } from '../../utils/common';
import { Button, Chip, Typography } from '@mui/material';
import DeleteIcon from "../../assets/images/icons/X.svg";
import instaIcon from "../../assets/images/icons/instaIcon.svg"
import rightCaretBlue from "../../assets/images/icons/rightCaretBlue.svg"
const filter = createFilterOptions();

export default function CustomAuto({ handleChange, values, type }) {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    let { filters } = useSelector((state) => state.dashboardSlice)
    const { niches } = useSelector((state) => state.commonSlice);
    let industries = niches?.map((v) => {
        return { title: v };
    });
    const [fieldOptions, setFieldOptions] = React.useState(industries.filter((v) => !values.categories.map((v) => v?.title).includes(v?.title)).slice(0, 7))

    const handleEnterKeyPress = (event) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            const searchValue = event.target.value.trim(); // Get trimmed search value

            if (searchValue) {
                let data = { showLoading:true,list:[],filters: { platform: values.platform || "Instagram", name: searchValue },limit:30,page:1,totalCount:0, };
                dispatch(updateDashboard(data));
                setSearchdata(JSON.stringify({ platform: values.platform || "Instagram", name: searchValue }));
                dispatch(getInfluencerListFordashboard());
                if (type == "dashboard") {
                    navigate("/discover-influencers/listing");
                }
                return false;
            }
        }
    };

    const handleManageFieldOption = (index) => {
        if (index + 1 < industries.length) {
            setFieldOptions(industries.filter((v) => !values.categories.map((v) => v?.title).includes(v?.title)))
        }
        else {
            setFieldOptions(industries.filter((v) => !values.categories.map((v) => v?.title).includes(v?.title)).slice(0, 7))
        }
    }

    return (
        <React.Fragment>
            <Autocomplete
                multiple={true}
                ListboxProps={{
                    sx: {
                        display: 'flex',
                        flexWrap: 'wrap',
                        gap: 1,
                        padding: '10px',
                        backgroundColor: 'white',
                        borderRadius: '12px',
                        justifyContent: "flex-start",
                        boxShadow: '0px 4px 15px 0px #0000001A',
                    },
                }}

                renderTags={(value, getTagProps) =>
                    value.map((option, index) =>
                    (
                        <Chip
                            key={option.title || option}
                            label={option.title || option}
                            {...getTagProps({ index })}
                            sx={{
                                background: 'white !important', color: '#726C6C !important',
                                borderRadius: '62px', border: '1px solid #CCCBCB', fontSize: '14px', fontWeight: '500',
                                padding: "5px 8px", height: '32px'
                            }}
                            deleteIcon={<img src={DeleteIcon} alt="delete icon" width={24} height={24} />} // Custom delete icon
                        />
                    ))
                }
                value={values.categories}
                onChange={(event, newValue) => {
                    if (newValue && newValue.length && newValue[newValue.length - 1].inputValue) {
                        filters = { ...filters };
                        delete filters.categories;
                        let name = newValue?.length > 0 ? newValue?.find((v) => v?.inputValue)?.inputValue : "";
                        let data = { showLoading:true,list:[],filters: { platform: values.platform || "Instagram", name: name },page:1,limit:30,totalCount:0, }
                        dispatch(updateDashboard(data));
                        dispatch(getInfluencerListFordashboard());
                        if (type == "dashboard") {
                            setSearchdata(JSON.stringify({ platform: values.platform || "Instagram", name: name }));
                            navigate("/discover-influencers/listing");
                        }
                    } else {
                        handleChange(event, newValue);

                    }
                }}
                limitTags={2}
                key={values?.categories?.length}
                defaultValue={values.categories}
                filterOptions={(options, params) => {
                    const filtered = filter(options, params);

                    if (params.inputValue !== '') {
                        filtered.push({
                            inputValue: params.inputValue,
                            title: `Influencers with the name "${params.inputValue}"`,
                        });
                    }

                    return filtered;
                }}

                id="free-solo-dialog-demo"
                options={fieldOptions}
                getOptionLabel={(option) => {
                    if (typeof option === 'string') {
                        return option;
                    }
                    if (option?.inputValue) {
                        return option?.inputValue;
                    }
                    return option?.title;
                }}
                selectOnFocus
                clearOnBlur
                handleHomeEndKeys
                renderOption={(props, option, { index }) => {
                    return (
                        <>{index === 0 && (<>
                            <li
                                style={{
                                    fontSize: "14px",
                                    fontWeight: "500",
                                    paddingLeft: '10px',
                                    paddingBottom: '0px',
                                    color: "#726C6C",
                                    width: '90%',
                                }}>Suggestions</li>
                            <br />
                        </>
                        )}
                            <li {...props} style={{ width: 'fit-content', margin: "0 5px", borderRadius: '62px', border: '1px solid #CCCBCB', fontSize: '14px', fontWeight: '500', height: '32px', color: '#726C6C' }}>{option.title}</li>
                            {index === fieldOptions.length - 1 && (
                                <>
                                    <li>
                                        <Button sx={{ height: '32px', borderRadius: '62px', border: '1px solid #0077FF', fontSize: '14px !important', fontWeight: '500 !important', fontFamily: 'var(--family1)' }} onClick={() => handleManageFieldOption(index)}>{index + 1 < industries.length ? "View More" : "View Less"} <img src={rightCaretBlue} alt="right caret" width={16} height={16} /></Button>
                                    </li>
                                    <li
                                        style={{
                                            fontSize: "14px",
                                            fontWeight: "500",
                                            paddingLeft: '10px',
                                            paddingTop: '10px',
                                            color: "#726C6C",
                                            width: '100%',
                                        }}
                                    >
                                        <p style={{
                                            marginBottom: '10px', fontSize: "14px !important",
                                            fontWeight: "500 !important",
                                        }}>Top List</p>
                                        <ul style={{ listStyle: 'none', padding: '0', gap: '10px', display: 'flex', flexDirection: 'column', color: '#2B2829' }}>
                                            <li style={{ display: 'flex', gap: '5px', alignItems: 'center' }}><img src={instaIcon} alt="instaicon" width={18} height={18} /><Typography sx={{ fontWeight: '400 !important', fontSize: '14px !important', color: '#2B2829 !important' }}>Top content creator of insatgram</Typography></li>
                                            <li style={{ display: 'flex', gap: '5px', alignItems: 'center' }}><img src={instaIcon} alt="instaicon" width={18} height={18} /><Typography sx={{ fontWeight: '400 !important', fontSize: '14px !important', color: '#2B2829 !important' }}>Top content creator of Instagram creator of Instagram</Typography></li>
                                        </ul></li></>)}</>)
                }}
                clearIcon={<ClearIcon fontSize="small" onClick={() => {
                    setSearchdata(JSON.stringify({ platform: filters.platform }));
                    dispatch(updateDashboard({list:[], filters: { platform: filters.platform },page:1,limit:30,totalCount:0 }));
                }} />}
                freeSolo
                renderInput={(params) => <TextField {...params} label="" onKeyDown={handleEnterKeyPress} placeholder={values?.categories?.length > 0 ? "Add More.." : "Categories, Name"} />}
            />

        </React.Fragment>
    );
}
